import Loadable from 'components/Loadable';

const setup = {
  path: '/setup',
  component: Loadable({
    loader: () => import('../views/setup'),
  }),
  routes: [
    {
      exact: true,
      path: '/setup/email',
      component: Loadable({
        loader: () => import('../views/setup/email'),
      }),
    },
    {
      path: '/setup/plans',
      component: Loadable({
        loader: () => import('../views/setup/plans'),
      }),
      routes: [
        {
          exact: true,
          path: '/setup/plans',
          component: Loadable({
            loader: () => import('../views/setup/plans/overview'),
          }),
        },
        {
          exact: true,
          path: '/setup/plans/checkout',
          component: Loadable({
            loader: () => import('../views/setup/plans/checkout'),
          }),
        },
      ],
    },
  ],
};

export default setup;
